/***** Sequence Animation *****/
var sequence = function() {
  $('.sequence, .cv-block p, .cv-block h2').each(function(i) {
  $(this).delay((i++) * 200).fadeTo(400, 1); })
}

export default sequence;



// WEBPACK FOOTER //
// ./source/scripts/modules/sequence.js